import { render, staticRenderFns } from "./BusScheduleTabs.vue?vue&type=template&id=edb8e950&scoped=true&"
import script from "./BusScheduleTabs.vue?vue&type=script&lang=js&"
export * from "./BusScheduleTabs.vue?vue&type=script&lang=js&"
import style0 from "./BusScheduleTabs.vue?vue&type=style&index=0&id=edb8e950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb8e950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCol,VDivider,VRow,VTab,VTabItem,VTabs,VTabsItems})
